import React from 'react';
import FormViewer from '../../../components/FormViewer';
import LoaderButton from '../../../components/LoaderButton';

import { checkTranslation, priceStandardView, translate } from '../../../utils/useful';
import ButtonAnimated from '../../../components/buttons/ButtonAnimated';
import HttpServices from '../../../utils/Http.services';

class AccountingInvoiceEdit extends React.Component {

    state = {

        paymentsHeaders: [
            { key: 'date', type: 'DateInput', col: '6', information: { label: '{{lang}}applets.accounting.invoiceDate', placeholder: '{{lang}}applets.accounting.invoiceDate', required: true }, showMain: true },
            { key: 'number', type: 'TextInput', col: '12', information: { label: '{{lang}}number', placeholder: '{{lang}}number', required: false, disabled: true }, showMain: true },
            { key: 'mode', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}Payment mode', required: true, type: 'local', default: '0', items: [{ title: "{{lang}}Cash", value: 'C', color: '#789' }, { title: "{{lang}}Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            { key: 'amount', type: 'PriceInput', col: '12', information: { label: '{{lang}}amount', placeholder: '{{lang}}amount', required: false, disabled: true }, showMain: true },

        ],
        invoiceHeaders: [
            { key: 'item', type: 'AdvancedSelectInput', col: '4', information: { label: '{{lang}}applets.accounting.itemDetails', address: 'ygetProducts', filter: { appletHub: '{{appletHub}}' }, fields: { title: '{lang}}name', image: 'images', value: '_id', price: 'price', unit: 'unit' }, type: 'api', isSearchable: true, placeholder: '{{lang}}product', required: false }, showMain: true },
            { key: 'quantity', type: 'NumberInput', col: '3', information: { label: '{{lang}}useful.quantity', placeholder: '{{lang}}useful.count', required: true } },
            { key: 'rate', type: 'PriceInput', col: '2', information: { label: '{{lang}}useful.rate', placeholder: '{{lang}}useful.rate', required: true } },
            { key: 'amount', type: 'PriceInput', col: '3', information: { label: '{{lang}}useful.amount', disabled: true, placeholder: '{{lang}}useful.amount', required: true } },

        ],

        paymentsData: []

    }

    componentDidMount() {
    }



    fetchSalesPerson = (customer) => {

        let body = {
            customer,
            applet: this.props.applet._id,
            appletHub: this.props.variables.appletHub
        }


        // console.log(body)

        HttpServices.request('getSalesPerson', body, (fetchResult, fetchError) => {

            // console.log(fetchResult)

            this.setState({ isLoadingPost: false })


            if (fetchError) {
                this.setState({ error: fetchError.message })
                return
            }

            if (!fetchResult.info) {
                fetchResult.info = {}
            }

            let invoice = { ...this.state.invoice }

            invoice.salesperson = fetchResult.info.salesperson

            invoice.commission = fetchResult.info.commission

            this.setState({ invoice })

            // console.log("success")
            // this.setState({ success: true, invoice: fetchResult.info }, () => {
            //     this.stageManager.changeStage('view')
            // })



        })


    }

    liveChange = (data, init, key, value, extra) => {
        this.setState({ invoice: data })

        if (key == 'customer') {
            // console.log(value)
            this.fetchSalesPerson(value)
        }
        // console.log(data)
    }




    render() {
        return (


            <div className="w-100 flexc flex-column pt-4 " style={{ padding: '0px 2%' }}>

                <div style={{ padding: '0% 0%' }}>
                    <FormViewer width={this.props.width} ref={el => this.form = el} headers={this.props.page?.headers} liveChange={this.liveChange} initData={this.state.invoice} errors={this.state.errors} inputClass={'modern-input '} variables={this.props.variables} />
                </div>

                <div className="blur-back w-100 flexc mb-5" style={{ }}>
                    <div className="row mx-0 w-100">
                        <div className="col-12 col-md-6 flexc">
                            <div className="" style={{}}>
                              
                                <ButtonAnimated
                                    iconwidth='28px'
                                    isLoading={this.props.isLoadingPost}
                                    onClick={this.props.postInvoice}
                                    title='{{lang}}Save'
                                    icon='/assets/icons/save.svg'
                                    invert={!this.props.colors?.iconInvert}
                                    bg={this.props.colors?.background}
                                    textColor={this.props.colors?.textColor}
                                />

                            </div>
                            {this.state.invoice?.number && (
                                <div className="mld-2">
                                    <LoaderButton
                                        onClick={this.cancel}
                                        isLoading={this.state.isLoading}
                                        text={translate("Cancel".toLowerCase()).toUpperCase()}
                                        type={"Oval"}
                                        className="mt-2 mb-2"
                                        buttonStyle={{ outline: 'none', background: 'linear-gradient(to left bottom, #e2e6e8, #e8e9f0', cursor: 'pointer', padding: '8px 40px', borderRadius: 4, fontSize: 14, fontWeight: 'bold', color: '#000', border: 'none' }}
                                        width={20}
                                        height={20}
                                        color={'#202020'}
                                    />
                                </div>
                            )}
                        </div>
                        {/* Comments in sv */}
                        {/* <div className="col-12 col-md-6 flexc d-none d-md-flex flexc justify-content-end">

                                                    <button className="flexcc" style={{ color: '#007aff' }}>
                                                        <div className="mrd-2 flexcc" style={{ height: 20, width: 20, borderRadius: 20, backgroundColor: '#007aff' }}><img className="invert" src="/images/light-bolt.svg" height="16px" /></div>
                                                        Extra Actions
                                                    </button>
                                                </div> */}
                    </div>

                    {/* <button onClick={() => this.props.lastStage()} className="text-small " style={{ color: '#789' }}>Back one stage?</button> */}

                </div>
            </div>

        )
    }
}


export default AccountingInvoiceEdit